import React from "react";
import {View, Text} from "react-native";

interface INotificationToast {
    message: string,
    mobileNumber: string
}

const NotificationToast = (props: INotificationToast) => {
    const {message, mobileNumber} = props;
    return (
        <View style={{flex: 1, flexDirection: "row", flexWrap: "wrap"}}>
            <img
                src={require("../../assets/whatsapp_icon.png")}
                alt={"Whatsapp"}
                style={{
                    width: "40px",
                    height: "40px"
                }} />
            <View style={{paddingHorizontal: 5}}>
                <Text>New Message from {mobileNumber}</Text>
                <Text style={{fontSize: "0.8rem"}}>{message.length < 20 ? message : message.substring(0, 20)+"..."}</Text>
            </View>
        </View>
    );
}

export default NotificationToast;